// import {COMMENT_REPLY_SET, COMMENT_REPLY_CANCEL} from 'app/redux/constants/actionTypes';

const initialState = {};
export default function metaTags(state = initialState, action) {
  // console.log('metaTags reducer', state, action)
  return state;
}